import "./components/tabs";
import "./components/popup-trigger";

(function () {
  "use strict";

  document.addEventListener("DOMContentLoaded", function () {
    initMenuToggle();
    initStickyHeader();
    initDetailsAnimation();
    initPopup();
  });

  function initMenuToggle() {
    const menuToggle = document.querySelector(".header__toggle");
    const navigation = document.querySelector(".header__nav");
    const body = document.body;

    if (!menuToggle || !navigation) {
      return;
    }

    menuToggle.addEventListener("click", function () {
      const isExpanded = menuToggle.getAttribute("aria-expanded") === "true";

      menuToggle.setAttribute("aria-expanded", !isExpanded);

      navigation.classList.toggle("toggled");

      body.classList.toggle("menu-open");
    });

    document.addEventListener("click", function (event) {
      if (
        !navigation.contains(event.target) &&
        !menuToggle.contains(event.target)
      ) {
        menuToggle.setAttribute("aria-expanded", "false");
        navigation.classList.remove("toggled");
        body.classList.remove("menu-open");
      }
    });

    document.addEventListener("keydown", function (event) {
      if (event.key === "Escape" && navigation.classList.contains("toggled")) {
        menuToggle.setAttribute("aria-expanded", "false");
        navigation.classList.remove("toggled");
        body.classList.remove("menu-open");
        menuToggle.focus();
      }
    });
  }

  function initStickyHeader() {
    const header = document.querySelector(".header");
    const headerImage = document.querySelector(".header__image-default");

    if (!header) {
      return;
    }

    let isSticky = false;
    const scrollThreshold = 50;

    function handleScroll() {
      const scrollTop =
        window.pageYOffset || document.documentElement.scrollTop;

      if (scrollTop > scrollThreshold && !isSticky) {
        // Add sticky class
        header.classList.add("header--sticky");
        isSticky = true;

        // Show the blue image when sticky
        if (headerImage) {
          headerImage.style.display = "block";
        }
      } else if (scrollTop <= scrollThreshold && isSticky) {
        // Remove sticky class
        header.classList.remove("header--sticky");
        isSticky = false;

        // Hide the blue image when not sticky
        if (headerImage) {
          headerImage.style.display = "none";
        }
      }
    }

    // Throttle scroll events for better performance
    let ticking = false;
    function requestTick() {
      if (!ticking) {
        requestAnimationFrame(handleScroll);
        ticking = true;
      }
    }

    function onScroll() {
      requestTick();
      ticking = false;
    }

    // Add scroll event listener
    window.addEventListener("scroll", onScroll, { passive: true });

    // Check initial scroll position
    handleScroll();
  }

  function initDetailsAnimation() {
    const details = document.querySelectorAll(".faqs__details");

    details.forEach((detail) => {
      const summary = detail.querySelector(".faqs__summary");
      const content = detail.querySelector(".faqs__answer");

      if (!summary || !content) return;

      // Track animation state to prevent conflicts
      let isAnimating = false;

      // Set initial closed state
      if (!detail.hasAttribute("open")) {
        content.style.maxHeight = "0";
        content.style.opacity = "0";
        content.style.paddingBottom = "0";
        content.style.overflow = "hidden";
      }

      // Handle click events
      summary.addEventListener("click", function (e) {
        e.preventDefault();

        if (isAnimating) return; // Prevent multiple clicks during animation

        const isOpen = detail.hasAttribute("open");
        isAnimating = true;

        if (isOpen) {
          // Start closing animation
          detail.classList.add("is-closing");
          detail.classList.remove("is-opening");

          // Animate to closed state
          content.style.maxHeight = "0";
          content.style.opacity = "0";
          content.style.paddingBottom = "0";

          // Remove open attribute after animation
          setTimeout(() => {
            detail.removeAttribute("open");
            detail.classList.remove("is-closing");
            isAnimating = false;
          }, 300);
        } else {
          // Set open attribute first
          detail.setAttribute("open", "");
          detail.classList.add("is-opening");
          detail.classList.remove("is-closing");

          // Get the natural height for animation
          const naturalHeight = content.scrollHeight;

          // Start from closed state
          content.style.maxHeight = "0";
          content.style.opacity = "0";
          content.style.paddingBottom = "0";

          // Trigger animation to open state
          requestAnimationFrame(() => {
            content.style.maxHeight = naturalHeight + "px";
            content.style.opacity = "1";
            content.style.paddingBottom = "20px";
          });

          // Clean up after animation
          setTimeout(() => {
            detail.classList.remove("is-opening");
            content.style.maxHeight = "none"; // Allow natural height
            isAnimating = false;
          }, 300);
        }
      });
    });
  }
})();
